import { Action, ActionCreator } from 'redux'

import { IActionSetLoaded, StartupActionTypes } from './types'

export const setLoaded: ActionCreator<Action> = (isLoaded: boolean): IActionSetLoaded => ({
  payload: isLoaded,
  type: StartupActionTypes.SET_LOADED
})
